import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { LoginGuard } from './login/login.guard';
import { StoryComponent } from './story/story.component';
import { UploadStoryComponent } from './upload-story/upload-story.component';
import { QuizComponent } from './quiz/quiz.component';
import { QuizSessionComponent } from './quiz-session/quiz-session.component';
import { UploadQuestionComponent } from './upload-question/upload-question.component';
import { PhotoUploadComponent } from './photo-upload/photo-upload.component';
import { LevelUpComponent } from './level-up/level-up.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { EditStoryComponent } from './edit-story/edit-story.component';
import { ProfileComponent } from './profile/profile.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { AvatarCreationComponent } from './avatar-creation/avatar-creation.component';
import { EditQuizComponent } from './edit-quiz/edit-quiz.component';
import { AboutComponent } from './about/about.component';
import { FindStudentListComponent } from './find-students/find-students-list.component';
import { ConnectRequestComponent } from './connect-request/connect-request.component';
import { MyStudentListComponent } from './my-students/my-students-list.component';
import { MyAssignmentComponent } from './my-assignments/my.assignment.component';
import { StorySessionComponent } from './story-session/story-session.component';

const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'upload', component: UploadStoryComponent, canActivate: [LoginGuard] , data: { title: 'Upload Story' }},
  { path: 'home', component: HomeComponent, canActivate: [LoginGuard], data: { title: 'Home' }},
  { path: 'story/:id/quiz', component: QuizComponent, canActivate: [LoginGuard], data: { title: 'Quizz' }},
  { path: 'story/:id', component: StoryComponent , canActivate: [LoginGuard], data: { title: 'Story' }},
  { path: 'quizSessions', component: QuizSessionComponent, canActivate: [LoginGuard], data: { title: 'Quiz Sessions' }},
  { path: 'findStudents', component: FindStudentListComponent, canActivate: [LoginGuard], data: { title: 'Find Students' }},
  { path: 'myStudents', component: MyStudentListComponent, canActivate: [LoginGuard], data: { title: 'My Students' }},
  { path: 'viewRequest', component: ConnectRequestComponent, canActivate: [LoginGuard], data: { title: 'Connect Requests' }},
  { path: 'viewAssignments', component: MyAssignmentComponent, canActivate: [LoginGuard], data: { title: 'My Assignements' }},
  { path: 'storySessions', component: StorySessionComponent, canActivate: [LoginGuard], data: { title: 'Story Sessions' }},
  { path: 'uploadQuestion', component: UploadQuestionComponent, canActivate: [LoginGuard], data: { title: 'Uplaod Question' }},
  { path: 'photoUpload', component: PhotoUploadComponent, canActivate: [LoginGuard], data: { title: 'Photo Upload' }},
  { path: 'levelUp', component: LevelUpComponent, canActivate: [LoginGuard], data: { title: 'My Level' }},
  { path: 'editStory', component: EditStoryComponent, canActivate: [LoginGuard], data: { title: 'Edit Story' }},
  { path: 'editQuiz', component: EditQuizComponent, canActivate: [LoginGuard], data: { title: 'Edit Story' }},
  { path: 'profile', component: ProfileComponent, data: { title: 'My Profile' }},
  { path: 'forgotPassword', component: ForgotPasswordComponent, data: { title: 'Forgot Password' }},
  { path: 'reset-password', component: ResetPasswordComponent, data: { title: 'Reset Password' } },
  { path: 'profile/avatarCreation', component: AvatarCreationComponent, data: { title: 'Avatar' }},
  // { path: 'editQuiz', component: EditQuizComponent},
  { path: 'about', component: AboutComponent, data: { title: 'About Us' }}
];

@NgModule({
  imports: [RouterModule.forRoot(routes), NgxChartsModule],
  exports: [RouterModule]
})
export class AppRoutingModule { }
